<script setup lang="ts">
import {ShowcaseItem} from "@/core/interfaces/showcase";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";

defineProps<{
    item: ShowcaseItem
}>();
</script>

<template>
  <div class="flex items-center self-center gap-1 text-primary">
    {{ item.value }}
    <InformationTooltip v-if="item.tooltip" class="w-4 h-4">
      <div class="max-w-xl">
        <span>{{ item.tooltip }}</span>
      </div>
    </InformationTooltip>
  </div>
</template>

<style scoped>

</style>
